import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ user: null, mfaSetup: false });
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ user: data.user, mfaSetup: data.mfa_setup_required });
    } catch (e) {
      if (e?.response?.status === 403) setState({ user: { role: "pending" }, mfaSetup: true });
      else setState({ user: false, mfaSetup: false });
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setState({ user: false, mfaSetup: false }); };
  return <AuthCtx.Provider value={{ ...state, refresh, logout, setState }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isStaff = (u) => u && ["admin", "professional", "operator"].includes(u.role);

export function RequireAuth({ kind, children }) {
  const { user, mfaSetup } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-10 text-center text-muted-foreground" role="status">Caricamento…</div>;
  if (!user) return <Navigate to={`/accedi?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (mfaSetup) return <Navigate to="/configura-mfa" replace />;
  if (kind === "staff" && !isStaff(user)) return <Navigate to="/area-clienti" replace />;
  if (kind === "client" && user.role !== "client") return <Navigate to="/admin" replace />;
  return children;
}
